import {isClientEntityComplex} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreatePlanNode} from "../view-model";

/**
 * Recursively marks all descendants of any complex entity as immutable.
 * The complex node itself is not modified by this function; only its descendants are.
 */
export const complexNodeDescendentsAreImmutable = (
  node: CreatePlanNode,
  inComplexBranch = false
): void => {
  const isComplex = isClientEntityComplex(node.source);

  // If we're already under a complex ancestor, this node becomes immutable
  if (inComplexBranch) {
    node.immutable = true;
  }

  // Recurse into children, propagating the complex branch flag
  node.children.forEach(child =>
    complexNodeDescendentsAreImmutable(child, inComplexBranch || isComplex)
  );
};
